import { SET_NEWS } from '@/store/mutation-types'
import service from '@/service'
import isEmpty from 'lodash/isEmpty'
import nbsp from '@/assets/js/nbsp'

const state = {
  news: []
}

const getters = {
  news (state, getters, { i18n }) {
    const urlSlug = news => (
      news.slug[i18n.locale] ? `${ news.id }-${ news.slug[i18n.locale] }` : news.id
    )

    const localizeNews = news => ({
      ...news,
      title: news.title[i18n.locale],
      desc: news.desc[i18n.locale],
      slug: news.slug[i18n.locale],
      // link: i18n.locale + '/p/' + news.slug[i18n.locale] ? `${ news.id }-${ news.slug[i18n.locale] }` : news.id
      link: i18n.locale + '/p/' + urlSlug(news)
    })

    return state.news
      .map(localizeNews)
  },
  newsSec (state, getters, { i18n }) {
    const urlSlug = news => (
      news.slug[i18n.locale] ? `${ news.id }-${ news.slug[i18n.locale] }` : news.id
    )

    const localizeNews = news => ({
      ...news,
      title: news.title[i18n.locale],
      desc: news.desc[i18n.locale],
      slug: news.slug[i18n.locale],
      link: i18n.locale + '/p/' + urlSlug(news)
    })

    return state.news
      .map(localizeNews)
      .slice(2, 4)
  }
}

const mutations = {
  [SET_NEWS] (state, news) {
    const createNews = (newsInst = {}) => ({
      id: +newsInst.id,
      title: {
        pl: nbsp(newsInst.name || newsInst.name_en),
        en: nbsp(newsInst.name_en || newsInst.name)
      },
      desc: {
        pl: nbsp(newsInst.description || newsInst.description_en),
        en: nbsp(newsInst.description_en || newsInst.description)
      },
      slug: {
        pl: newsInst.slug || '',
        en: newsInst.slug_en || ''
      },
      photo: newsInst.imgUrl || newsInst.imgUrl_2x
    })
    state.news = news.map(createNews)
  }
}

const actions = {
  fetchNews ({ state, commit }) {
    if (!isEmpty(state.news)) return Promise.resolve()
    return service.home.news().then((res = {}) => {
      commit(SET_NEWS, res.works)
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/home.js